import React, { useEffect } from 'react';
import { applyColorsFromStorage } from '../utils/colorTheme';

/**
 * Provider de cores dinâmicas que aplica as cores automaticamente
 * Deve ser usado no componente raiz da aplicação
 */
const ColorThemeProvider = ({ children }) => {
  useEffect(() => {
    // Aplica as cores quando o componente monta
    applyColorsFromStorage();
    
    // Aplica as cores quando a página é carregada
    const handleLoad = () => {
      applyColorsFromStorage();
    };
    
    // Aplica as cores quando o localStorage muda (se o usuário fizer login em outra aba)
    const handleStorageChange = (e) => {
      if (e.key === 'login-data') {
        applyColorsFromStorage();
      }
    };
    
    window.addEventListener('load', handleLoad);
    window.addEventListener('storage', handleStorageChange);
    
    // Cleanup
    return () => {
      window.removeEventListener('load', handleLoad);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return <>{children}</>;
};

export default ColorThemeProvider;
